<template>
  <router-view id="app" />
</template>

<script>
  export default {
    data() {
      return {
        refreshing: false,
        registration: null,
        updateExists: false,
        isRouterAlive: true,
      };
    },
    
    created() {
      document.addEventListener("swUpdated", this.showRefreshUI, {
        once: true
      });
      // Refresh all open app tabs when a new service worker is installed.
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (this.refreshing) return;
        this.refreshing = true;
        window.location.reload();
      });
    },

    methods: {
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true;
        });
      },
      showRefreshUI(e) {
        // Display a button inviting the user to refresh/reload the app due
        // to an app update being available.
        // The new service worker is installed, but not yet active.
        // Store the ServiceWorkerRegistration instance for later use.
        this.registration = e.detail;
        this.updateExists = true;
        if (this.updateExists) {
          this.refreshApp();
        }
        // this.registration.waiting.postMessage("refresh");
        console.log("refresh");
      },
      refreshApp() {
        // Handle a user tap on the update app button.
        this.updateExists = false;
        // Protect against missing registration.waiting.
        if (!this.registration || !this.registration.waiting) {
          console.log("New.");
          return;
        }
        this.registration.waiting.postMessage("skipWaiting");
      }
    },
  }

</script>

<style lang="scss">
  html,
  body {
    height: 100%;
  }

  #app {
    height: 100%;
    font-family: "微軟正黑體";
  }

  #header {
    box-shadow: 0 1px 3px rgba(0, 0, 0, .1);
  }

  .mynavbtn {
    a {
      color: black !important;

      &:hover {
        color: #ab7c14 !important;
      }
    }
  }

  .min-vh-75 {
    min-height: 75vh !important;
  }

</style>
